<template>
  <div id="mudanca-territorio" class="row">
    <div class="col-md-12">
      <selects
        :callbackOnChangeEquipe="onChangeEquipe"
        :activeOptionSemEquipe="true"
        :callbackOnChangeProfissional="onChangeProfissional"
        :activeSelectMicroArea="true"
        :callbackOnChangeMicroArea="onChangeMicroArea"
      ></selects>
    </div>
    <div class="col-md-12">
      <b-tabs
        id="tabs-1"
        key="tabs-1"
        fill
        class="esus-feedback-tabs"
        v-model="tabsActive"
      >
        <b-tab title="Lista" active @click="buscarDadosDaLista()">
          <template v-slot:title> <i class="icofont-list"></i> Lista </template>
          <div class="row">
            <div class="full-table">
              <div class="col-md-12">
                <div class="info-table">
                  <div class="info-table-item">
                    <Subtitle
                      @exibirVermelhos="handleExibirVermelhos"
                      @exibirVerdes="handleExibirVerdes"
                      :setRed="setRed"
                      @resetarNome="setRed = false"
                    ></Subtitle>
                  </div>
                  <div class="info-table-item">
                    <download-files
                      :callback-pdf="generatePdf"
                      :data="displayedCadastros"
                      :fields="dataFields"
                      name="mudanca_territorio"
                    >
                    </download-files>
                  </div>
                </div>
                <tabela-cadastros
                  ref="table"
                  :cadastros="displayedCadastros"
                  :loading="loadingLista"
                  @filterSearch="filterSearch($event)"
                ></tabela-cadastros>
              </div>
            </div>
          </div>
        </b-tab>
      </b-tabs>
    </div>
  </div>
</template>

<script>
import Loader from '@/components/Loader'
import Subtitle from './Subtitle'
import PulseLoader from 'vue-spinner/src/PulseLoader.vue'
import * as Functions from './functions'
import TabelaCadastros from './TabelaCadastros.vue'
import { dataFields, infoHtml } from './utils.js'
import utils from '@/mixins/utils.js'
import DownloadFiles from '@/components/utils/DownloadFiles.vue'
import Selects from '@/components/utils/Selects.vue'

export default {
  name: 'MudancaTerritórioPorEquipeAcs',
  components: {
    PulseLoader,
    Loader,
    Subtitle,
    TabelaCadastros,
    DownloadFiles,
    Selects,
  },
  mixins: [utils],
  data() {
    return {
      equipe: '',
      profissionais: [],
      profissional: '',
      cadastros: [],
      loadingLista: false,
      tabsActive: 0,
      nomeProfissional: '',
      exibirCadastrosVermelhos: false,
      exibirCadastrosVerdes: false,
      micro_areas: [],
      micro_area: '',
      dataFields: {
        ...dataFields,
      },
      cadastrosOriginais: [],
      setRed: false,
      text: infoHtml,
      filterSearchTable: false,
    }
  },
  computed: {
    displayedCadastros() {
      if (this.filterSearchTable != false) {
        return this.filterSearchTable
      }
      return this.cadastros
    },
  },
  methods: {
    /**
     * Atualiza o estado do filtro de busca da tabela.
     * @param {Object} item Item selecionado
     */
    filterSearch(item) {
      if (item.filter !== false) {
        this.filterSearchTable = item.filter
        return
      }
      this.filterSearchTable = false
    },

    /**
     * Habilita os filtros vermelho/verde
     *
     * @param {Boolean} vermelho
     * @param {Boolean} verde
     */
    filtros(vermelho, verde) {
      if (this.$refs.table) {
        this.$refs.table.search = ''
      }
      let data = this.cadastrosOriginais

      if (vermelho === true) {
        data = Functions.exibirVermelhos(data)
        this.exibirCadastrosVerdes = false
        this.exibirCadastrosVermelhos = true
      }
      if (verde === true) {
        data = Functions.exibirVerdes(data)
        this.exibirCadastrosVermelhos = false
        this.exibirCadastrosVerdes = true
      }
      this.cadastros = data
    },

    /**
     * Atualiza o filtro para exibir registros classificados como vermelhos.
     * @param {Boolean} event Indica se o filtro deve ser aplicado
     */
    handleExibirVermelhos(event) {
      if (event == true) {
        // mostra os vermelhos
        this.filtros(true, false)
        this.exibirCadastrosVermelhos = true
        this.exibirCadastrosVerdes = false
      } else {
        this.filtros(false, false)
        this.exibirCadastrosVermelhos = false
      }
    },

    /**
     * Atualiza o filtro para exibir registros classificados como verdes.
     * @param {Boolean} event Indica se o filtro deve ser aplicado
     */
    handleExibirVerdes(event) {
      if (event == true) {
        // mostra os verdes
        this.filtros(false, true)
        this.exibirCadastrosVerdes = true
        this.exibirCadastrosVermelhos = false
      } else {
        this.filtros(false, false)
        this.exibirCadastrosVerdes = false
      }
    },

    /**
     * Manipula a alteração da equipe selecionada.
     *
     * @param {Object} event Equipe selecionada
     */
    async onChangeEquipe(event) {
      if (this.$refs.table) {
        this.$refs.table.search = ''
      }
      if (event !== null) {
        this.equipe = event
        this.tabsActive = 0
        this.profissionais = []
        this.cadastros = []
        this.cadastrosOriginais = []
        this.buscarCadastrosIndividuaisTodosPorEquipe()
      } else {
        this.profissionais = []
        this.profissional = ''
        this.tabsActive = 0
        this.micro_area = ''
        this.micro_areas = []
        this.cadastros = []
        this.cadastrosOriginais = []
        this.equipe = ''

        return
      }
    },

    /**
     * Manipula a alteração da profissional selecionado.
     *
     * @param {Object} event Profissional selecionada
     */
    onChangeProfissional(event) {
      if (this.$refs.table) {
        this.$refs.table.search = ''
      }
      if (event !== null) {
        this.profissional = event?.nu_cpf
        this.nomeProfissional = event?.no_profissional
        this.tabsActive = 0
        this.page = 1
        if (this.profisional == null) {
          this.tabsActive = 0
        }
        this.buscarDadosDaLista()
      } else {
        this.cadastros = []
        this.cadastrosOriginais = []
        this.temAcs = false
        this.profissional = ''
        this.nomeProfissional = ''
        this.tabsActive = 0
        this.onChangeEquipe(this.equipe)
        return
      }
    },

    /**
     * Manipula a alteração da microárea selecionada.
     *
     * @param {Object} event Microárea selecionada
     */
    async onChangeMicroArea(event) {
      if (this.$refs.table) {
        this.$refs.table.search = ''
      }
      if (event !== null) {
        this.loadingLista = true
        this.nomeProfissional = ''
        this.profissional = null
        this.tabsActive = 0
        this.micro_area = event?.micro_area
        if (this.micro_area == undefined) {
          this.tabsActive = 0
        }
        if (this.micro_area !== undefined) {
          let response = await Functions.getCadastrosIndividuaisPorMicroArea(
            this.$store.state.cod_ibge,
            this.equipe.nu_ine,
            this.micro_area
          )
          if (response) {
            this.cadastrosOriginais = response
            this.cadastros = response
            this.tabsActive = 0
            this.filtros(true, false)
            this.setRed = true
            this.loadingLista = false
          }
        }
      } else {
        this.cadastrosOriginais = []
        this.cadastros = []
        this.nomeProfissional = ''
        this.profissional = null
        this.filtros(true, false)
        this.setRed = true
        this.tabsActive = 0
        this.onChangeEquipe(this.equipe)
      }
    },

    /**
     * Buscar os dados
     */
    async buscarDadosDaLista() {
      if (this.profissional !== '' && this.profissional !== null) {
        this.loadingLista = true
        try {
          const profissional = await this.$api.get(
            '/app/profissional/' +
              this.profissional +
              '/' +
              this.$store.state.cod_ibge
          )
          let response = await Functions.getCadastrosIndividuais(
            this.$store.state.cod_ibge,
            profissional.data.nu_cpf
          )
          if (response) {
            this.cadastros = response
            this.cadastrosOriginais = response
            this.filtros(true, false)
            this.setRed = true
          }
        } catch (error) {
          console.log(error)
        } finally {
          this.loadingLista = false
        }
      }
    },

    /**
     * Buscar dados por equipe
     */
    async buscarCadastrosIndividuaisTodosPorEquipe() {
      this.loadingLista = true
      let response = await Functions.getCadastrosIndividuaisTodosPorEquipe(
        this.$store.state.cod_ibge,
        this.equipe.nu_ine
      )
      if (response) {
        this.cadastrosOriginais = response
        this.cadastros = response
        this.filtros(true, false)
        this.setRed = true
        this.loadingLista = false
      }
    },

    /**
     * Gera o relatório em PDF.
     */
    generatePdf() {
      Functions.generatePdf(
        this.displayedCadastros,
        this.equipe,
        this.profissional,
        this.nomeProfissional
      )
    },
  },
}
</script>

<style></style>
